"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeGetCurrencyById = exports.getCurrenciesMap = exports.getCurrencies = exports.getIsLoading = void 0;

var R = _interopRequireWildcard(require("ramda"));

var _utils = require("@alycecom/utils");

var _currencies = require("./currencies.reducer");

var getCurrenciesState = function getCurrenciesState(state) {
  return state.modules.currencies;
};

var selectors = _currencies.currenciesAdapter.getSelectors(getCurrenciesState);

var getIsLoading = R.pipe(getCurrenciesState, function (state) {
  return state.status === _utils.StateStatus.Pending;
});
exports.getIsLoading = getIsLoading;
var getCurrencies = selectors.getAll;
exports.getCurrencies = getCurrencies;
var getCurrenciesMap = selectors.getEntities;
exports.getCurrenciesMap = getCurrenciesMap;

var makeGetCurrencyById = function makeGetCurrencyById(currencyId) {
  return R.pipe(getCurrenciesMap, function (currenciesMap) {
    return currenciesMap[currencyId];
  });
};

exports.makeGetCurrencyById = makeGetCurrencyById;